// material-ui

import shippingbookingicon from '../../../assets/images/shipping_booking.svg';
/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const ShippingBookingIcon = () => {
    

    return (
        /**
         * if you want to use image instead of svg uncomment following, and comment out <svg> element.
         *
         * <img src={logo} alt="Berry" width="100" />
         *
         */
         <img src={shippingbookingicon} alt="Shipping booking" width="22"  />
    );
};

export default ShippingBookingIcon;